import { type FC } from "react";
import { Button, Stack } from "~/common/mui";
import Modal from "~/common/components/Modal";
import { useTranslation } from "react-i18next";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";

interface Props {
  onCancel: () => void;
  onOverride: () => void;
  onAdd: () => void;
}

const CartContainsItemsModal: FC<Props> = ({ onCancel, onOverride, onAdd }) => {
  const { t } = useTranslation();
  const webservicesDisabled = window.SCHA.config.disableAllWS;
  return (
    <Modal
      onClose={onCancel}
      title={t("orderDetailsPage.explanation.header")}
      footerChildren={
        <div className="d-flex flex-justify-between flex-align-center w-100">
          <Button variant={"text"} onClick={onCancel}>
            {t("bulkUpload.buttons.cancel")}
          </Button>
          <Stack direction={"row"} gap={1}>
            <Button
              color={"secondary"}
              onClick={onOverride}
              startIcon={<ShoppingCartIcon sx={{ fontSize: { phone: 16, tablet: 20 } }} />}
              disabled={webservicesDisabled}
            >
              {t("bulkUpload.buttons.override")}
            </Button>
            <Button
              onClick={onAdd}
              startIcon={<ShoppingCartIcon sx={{ fontSize: { phone: 16, tablet: 20 } }} />}
              disabled={webservicesDisabled}
            >
              {t("bulkUpload.buttons.add")}
            </Button>
          </Stack>
        </div>
      }
    >
      <ul>
        <li>{t("orderDetailsPage.explanation.add")}</li>
        <li>{t("orderDetailsPage.explanation.override")}</li>
      </ul>
    </Modal>
  );
};

export default CartContainsItemsModal;
